module.exports = {
    QUIZ: { description: 'Notificação de Questionário', code: 1 },
    CAMPAIGN: { description: 'Notificação de Campanha e Conteúdos', code: 2 },
    CUSTOM: { description: 'Notificação Personalizada', code: 3 }, 
}